import React, { useState, useEffect, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";
import SidebarLinkGroup from "./SidebarLinkGroup";

import { useDispatch, useSelector } from "react-redux";
import { login_Success } from "../../redux/auth/authSlice";

import { TbDashboard } from "react-icons/tb";

//icons
import RR from "../../assets/images/icons/R&R.png";
import LD from "../../assets/images/icons/L&D.png";
import RSP from "../../assets/images/icons/RSP.png";
import PM from "../../assets/images/icons/PM.png";
import dashboard from "../../assets/images/icons/dashboard.png";
import pds from "../../assets/images/icons/personal-information.png";

import role from "../../assets/images/icons/role.png";
import set1 from "../../assets/images/icons/settings (1).png";

import recyclebin from "../../assets/images/icons/recycle-bin.png";
import data from "../../assets/images/icons/data.png";
import email from "../../assets/images/icons/email.png";
import { FaPencilAlt } from "react-icons/fa";
import TaskConsts from "constants/TaskConsts";
import fetchUtils from "utils/fetchData";
import { useBigContext } from "utils/bigContext";
import fetchData from "utils/fetchData";

const Sidebar = ({ sidebarOpen, setSidebarOpen }) => {
  const cookies = document.cookie.split(";").reduce((prev, curr) => {
    const [name, value] = curr.trim().split("=");
    prev[name] = value;
    return prev;
  }, {});
  const [id, setID] = useState(cookies.ID);
  const location = useLocation();
  const { pathname } = location;
  const dispatch = useDispatch();

  const users = `${window.globalConfig.BASE_URL2}/api/Users`;
  const roles = `${window.globalConfig.BASE_URL2}/api/Roles`;
  const RandR = `${window.globalConfig.BASE_URL2}/api/RandR`;
  const onboarding = `${window.globalConfig.BASE_URL2}/api/EmployeesForOnBoardings`;

  const imageUrl = `${window.globalConfig.BASE_IMAGE}`;

  const trigger = useRef(null);
  const sidebar = useRef(null);

  const userTasks = useSelector((state) => state.auth.userTasks)?.split(",");
  const isJudge = useSelector((state) => state.auth.isJudge);
  const isCoachMentor = useSelector((state) => state.auth.isCoachMentor);
  const isDeptHead = useSelector((state) => state.auth.isDeptHead);
  const { bigContextState, setBigContextState } = useBigContext();

  useEffect(() => {
    const handlePageRefresh = (event) => {
      //Check if the page is being refreshed
    };

    //Attach the event listener to the 'beforeunload' event
    window.addEventListener("beforeunload", handlePageRefresh);

    //Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("beforeunload", handlePageRefresh);
    };
  }, []);

  //close on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!sidebar.current || !trigger.current) return;
      if (
        !sidebarOpen ||
        sidebar.current.contains(target) ||
        trigger.current.contains(target)
      )
        return;
      setSidebarOpen(false);
    };
    document.addEventListener("click", clickHandler);
    return () => document.removeEventListener("click", clickHandler);
  }, []);

  useEffect(() => {
    if (bigContextState?.hrmpsbVisible) return;
    // if (isAdmin) {
    //   setBigContextState(
    //     value => {
    //       return { ...value, hrmpsbVisible: true }
    //     }
    //   );
    //   return;
    // }

    if (
      (bigContextState?.jobPositionsAsInterviewerCount > 0)
      || userTasks?.some(
        (item) =>
          item === "00000000-0000-AAAA-AAAA-000000000001" ||
          item == TaskConsts.HrmpsbTableViewAll
      )
    ) {
      setBigContextState((value) => {
        return { ...value, hrmpsbVisible: true };
      });
      return;
    }

    // (async function() {
    //   try {
    //     const response = await fetchUtils.Post('/api/JobPositions/GetCount', {
    //       CurrentUserAsInterviewer: true,
    //       showArchived: true
    //     });
    //     if (parseInt(response) > 0)
    //       setBigContextState(
    //         value => {
    //           return { ...value, hrmpsbVisible: true }
    //         }
    //       );
    //   } catch (error) {
    //     // just ignore errors here
    //     console.warn(error);
    //   }
    // })();
  }, [userTasks, bigContextState]);

  //close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!sidebarOpen || keyCode !== 27) return;
      setSidebarOpen(false);
    };
    document.addEventListener("keydown", keyHandler);
    return () => document.removeEventListener("keydown", keyHandler);
  }, []);

  const [saveChecker, setSaveChecker] = useState(
    cookies.profileChecker === "true" ? true : false
  );

  useEffect(() => {
    setSaveChecker(cookies.profileChecker === "true" ? true : false);
  }, [cookies.profileChecker]);
  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const response = await fetch(`${users}/GetSingle`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          mode: "cors",
          credentials: "include",
          body: JSON.stringify({
            ID: id,
          }),
        });

        const jsonData = await response.json();
        setSaveChecker(jsonData.user.birthDate ? true : false);
        document.cookie = `profileChecker=${jsonData.user.birthDate ? true : false
          }; expires=0; path=/;`;

        const response2 = await fetch(`${roles}/Get`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          mode: "cors",
          credentials: "include",
          body: JSON.stringify({
            ID: jsonData.userRoles[0]?.roleID,
          }),
        });
        const jsonData2 = await response2.json();
        const AdminChecker = jsonData2.rows[0]?.tasks;

        const response4 = await fetch(`${RandR}/getSkedAwardsPerJudge`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          mode: "cors",
          credentials: "include",
          body: JSON.stringify({
            parameter_1: id,
          }),
        });
        const judge = await response4.json();
        document.cookie = `isJudge=${judge.length > 0 ? true : false
          }; expires=0; path=/;`;
        const response5 = await fetch(`${onboarding}/Get`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          mode: "cors",
          credentials: "include",
          body: JSON.stringify({
            ID: null,
          }),
        });
        const jsonData5 = await response5.json();
        const filteredArray = jsonData5.rows.filter(
          (item) => item.coachID === id || item.mentorID === id
        );
        document.cookie = `isCoachMentor=${filteredArray.length > 0 ? true : false
          }; expires=0; path=/;`;

        document.cookie = `RoleID=${jsonData.userRoles[0]?.roleID}; expires=0; path=/;`;
        document.cookie = `RoleName=${jsonData.userRoles[0]?.roleName}; expires=0; path=/;`;
        document.cookie = `Tasks=${jsonData2.rows[0]?.tasks}; expires=0; path=/;`;
        if (
          AdminChecker?.length > 0 &&
          AdminChecker[0] != "null" &&
          AdminChecker[0] != ""
        ) {
          if (
            AdminChecker?.some(
              (item) => item === "33C2EDA2-73AD-438E-B79A-7A9622DDE5F4"
            ) &&
            AdminChecker?.length < 2
          ) {
            document.cookie = `isEmployee=false; expires=0; path=/;`;
          } else {
            document.cookie = `isEmployee=true; expires=0; path=/;`;
          }
        } else {
          document.cookie = `isEmployee=false; expires=0; path=/;`;
        }
        if (
          AdminChecker?.length > 0 &&
          AdminChecker[0] != "null" &&
          AdminChecker[0] != ""
        ) {
          if (
            AdminChecker?.some(
              (item) => item === "33C2EDA2-73AD-438E-B79A-7A9622DDE5F4"
            ) &&
            AdminChecker?.length < 3
          ) {
            document.cookie = `isAdmin=false; expires=0; path=/;`;
            dispatch(
              login_Success({
                userRole: `${jsonData.userRoles[0]?.roleName}`,
                userTasks: `${jsonData2.rows[0]?.tasks}`,
                hasProfile: jsonData.user.birthDate ? true : false,
                isJudge: judge.length > 0 ? true : false,
                isCoachMentor: filteredArray.length > 0 ? true : false,
                isLoggedIn: true,
                isAdmin: false,
                isEmployee:
                  AdminChecker?.length > 0 &&
                    AdminChecker[0] != "null" &&
                    AdminChecker[0] != "" &&
                    !(
                      AdminChecker?.some(
                        (item) => item === "33C2EDA2-73AD-438E-B79A-7A9622DDE5F4"
                      ) && AdminChecker?.length < 2
                    )
                    ? true
                    : false,
              })
            );
          } else {
            dispatch(
              login_Success({
                userRole: `${jsonData.userRoles[0]?.roleName}`,
                userTasks: `${jsonData2.rows[0]?.tasks}`,
                hasProfile: jsonData.user.birthDate ? true : false,
                isJudge: judge.length > 0 ? true : false,
                isCoachMentor: filteredArray.length > 0 ? true : false,
                isLoggedIn: true,
                isAdmin: true,
                isEmployee:
                  AdminChecker?.length > 0 &&
                    AdminChecker[0] != "null" &&
                    AdminChecker[0] != "" &&
                    !(
                      AdminChecker?.some(
                        (item) => item === "33C2EDA2-73AD-438E-B79A-7A9622DDE5F4"
                      ) && AdminChecker?.length < 2
                    )
                    ? true
                    : false,
              })
            );
            document.cookie = `loggedIn=true; expires=0; path=/;`;
            document.cookie = `isAdmin=true; expires=0; path=/;`;
          }
        } else {
          document.cookie = `isAdmin=false; expires=0; path=/;`;
          setTimeout(() => {
            dispatch(
              login_Success({
                userRole: `${jsonData.userRoles[0]?.roleName}`,
                userTasks: `${jsonData2.rows[0]?.tasks}`,
                hasProfile: jsonData.user.birthDate ? true : false,
                isJudge: judge.length > 0 ? true : false,
                isCoachMentor: filteredArray.length > 0 ? true : false,
                isLoggedIn: true,
                isAdmin: false,
                isEmployee:
                  AdminChecker?.length > 0 &&
                    AdminChecker[0] != "null" &&
                    AdminChecker[0] != "" &&
                    !(
                      AdminChecker?.some(
                        (item) => item === "33C2EDA2-73AD-438E-B79A-7A9622DDE5F4"
                      ) && AdminChecker?.length < 2
                    )
                    ? true
                    : false,
              })
            );
          }, 2500);
        }
      } catch (error) { }
    };
    fetchUserRole();
  }, []);
  const [preQualisPresent, setPreQualisPresent] = useState(
    userTasks?.some((item) => item === "33C2EDA2-73AD-438E-B79A-7A9622DDE5F4")
  );
  const [rolesisPresent, setRolesisPresent] = useState(
    userTasks?.some((item) => item === "ACA50AA8-3666-49DD-9B61-F0E146B23663")
  );
  const [usersisPresent, setUsersisPresent] = useState(
    userTasks?.some((item) => item === "84253EEA-122E-471E-B117-7A46988192CB")
  );
  const [addPreQualIsPresent, setAddPreQualIsPresent] = useState(
    userTasks?.some((item) => item === "758A10F7-AFBC-4D36-81EA-D9D48C9ADD43")
  );
  const [editPreQualIsPresent, setEditPreQualIsPresent] = useState(
    userTasks?.some((item) => item === "905A976B-4375-492E-BB51-EEC1976C3F2C")
  );
  const [deletePreQualIsPresent, setDeletePreQualIsPresent] = useState(
    userTasks?.some((item) => item === "41555934-4071-4DAB-B144-E6A56CAEB440")
  );
  const [onboardingIsPresent, setOnboardingIsPresent] = useState(
    userTasks?.some((item) => item === "1F6F3A3F-9731-4670-AF7A-4BC1B0475F95")
  );
  const [onboardingID, setOnboardingID] = useState();
  const [approvedonboardingIsPresent, setApprovedOnboardingIsPresent] =
    useState(
      userTasks?.some((item) => item === "C091F9F7-23D4-4C5D-B920-1E8D82C2AC82")
    );
  const [returnonboardingIsPresent, setReturnOnboardingIsPresent] = useState(
    userTasks?.some((item) => item === "F3750B1A-9B65-42F2-97DF-10B24996F8F0")
  );
  const [rejectonboardingIsPresent, setRejectOnboardingIsPresent] = useState(
    userTasks?.some((item) => item === "6ED786DD-FF04-4DE3-8E94-B2FA80BDD7A0")
  );
  const [setDatenoboardinglIsPresent, setSetDateOnboardingIsPresent] = useState(
    userTasks?.some((item) => item === "5D0D2CF7-5518-4F00-9A18-8BDA974FC521")
  );
  const [departmentIsPresent, setDepartmentIsPresent] = useState(
    userTasks?.some((item) => item === "97EAC233-CB4E-4F98-B30D-BC9048C435BB")
  );
  const [isAdmin, setisAdmin] = useState(cookies.isAdmin === "true");
  const [isEmployee, setIsEmployee] = useState(cookies.isEmployee === "true");

  useEffect(() => {
    if (onboardingID != null)
      return;
    (async () => {
      try {
        var pResponse = await fetchData.Post('/api/EmployeesForOnBoardings/Get', {
          EmployeeID: id
        });
        if (pResponse.fullCount > 0) 
          setOnboardingID(pResponse.rows[0].id);
        else
          setOnboardingID('');
      } catch (error) {
        if (error == 'The specified record does not exist.')
          setOnboardingID('');
        else
          console.error(error)
      }
    })();
  }, [onboardingIsPresent, isDeptHead]);

  useEffect(() => {
    setPreQualisPresent(
      userTasks?.some((item) => item === "33C2EDA2-73AD-438E-B79A-7A9622DDE5F4")
    );
    setRolesisPresent(
      userTasks?.some((item) => item === "ACA50AA8-3666-49DD-9B61-F0E146B23663")
    );
    setUsersisPresent(
      userTasks?.some((item) => item === "84253EEA-122E-471E-B117-7A46988192CB")
    );
    setAddPreQualIsPresent(
      userTasks?.some((item) => item === "758A10F7-AFBC-4D36-81EA-D9D48C9ADD43")
    );
    setEditPreQualIsPresent(
      userTasks?.some((item) => item === "905A976B-4375-492E-BB51-EEC1976C3F2C")
    );
    setDeletePreQualIsPresent(
      userTasks?.some((item) => item === "41555934-4071-4DAB-B144-E6A56CAEB440")
    );
    setOnboardingIsPresent(
      userTasks?.some((item) => item === "1F6F3A3F-9731-4670-AF7A-4BC1B0475F95")
    );
    setApprovedOnboardingIsPresent(
      userTasks?.some((item) => item === "C091F9F7-23D4-4C5D-B920-1E8D82C2AC82")
    );
    setReturnOnboardingIsPresent(
      userTasks?.some((item) => item === "F3750B1A-9B65-42F2-97DF-10B24996F8F0")
    );
    setRejectOnboardingIsPresent(
      userTasks?.some((item) => item === "6ED786DD-FF04-4DE3-8E94-B2FA80BDD7A0")
    );
    setSetDateOnboardingIsPresent(
      userTasks?.some((item) => item === "5D0D2CF7-5518-4F00-9A18-8BDA974FC521")
    );
    setDepartmentIsPresent(
      userTasks?.some((item) => item === "97EAC233-CB4E-4F98-B30D-BC9048C435BB")
    );
    if (userTasks?.length > 0 && userTasks[0] != "null" && userTasks[0] != "") {
      if (
        userTasks?.some(
          (item) => item === "33C2EDA2-73AD-438E-B79A-7A9622DDE5F4"
        ) &&
        userTasks?.length < 3
      ) {
        setisAdmin(false);
        document.cookie = `isAdmin=false; expires=0; path=/;`;
      } else {
        setisAdmin(true);
        document.cookie = `isAdmin=true; expires=0; path=/;`;
      }
    } else {
      setisAdmin(false);
      document.cookie = `isAdmin=false; expires=0; path=/;`;
    }

    if (userTasks?.length > 0 && userTasks[0] != "null" && userTasks[0] != "") {
      if (
        userTasks?.some(
          (item) => item === "33C2EDA2-73AD-438E-B79A-7A9622DDE5F4"
        ) &&
        userTasks?.length < 2
      ) {
        setIsEmployee(false);
        document.cookie = `isEmployee=false; expires=0; path=/;`;
      } else {
        setIsEmployee(true);
        document.cookie = `isEmployee=true; expires=0; path=/;`;
      }
    } else {
      setIsEmployee(false);
      document.cookie = `isEmployee=false; expires=0; path=/;`;
    }
  }, [userTasks]);
  return (
    <>
      <div className="">
        <aside
          ref={sidebar}
          className={`absolute left-0 top-0 z-9999 flex h-screen w-72.5 flex-col overflow-y-hidden bg-blue-900  duration-300 ease-linear dark:bg-boxdark lg:static lg:translate-x-0 ${sidebarOpen ? "translate-x-0" : "-translate-x-full"
            }`}
        >
          {/* <!-- SIDEBAR HEADER --> */}
          <div className="gap-2 px-6 py-5.5 lg:py-6.5 max-h-screen ">
            <button
              ref={trigger}
              onClick={() => setSidebarOpen(!sidebarOpen)}
              aria-controls="sidebar"
              aria-expanded={sidebarOpen}
              className="block lg:hidden self-start justify-start"
            >
              <svg
                className="fill-current"
                width="20"
                height="18"
                color="white"
                viewBox="0 0 20 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19 8.175H2.98748L9.36248 1.6875C9.69998 1.35 9.69998 0.825 9.36248 0.4875C9.02498 0.15 8.49998 0.15 8.16248 0.4875L0.399976 8.3625C0.0624756 8.7 0.0624756 9.225 0.399976 9.5625L8.16248 17.4375C8.31248 17.5875 8.53748 17.7 8.76248 17.7C8.98748 17.7 9.17498 17.625 9.36248 17.475C9.69998 17.1375 9.69998 16.6125 9.36248 16.275L3.02498 9.8625H19C19.45 9.8625 19.825 9.4875 19.825 9.0375C19.825 8.55 19.45 8.175 19 8.175Z"
                  fill=""
                />
              </svg>
            </button>
            <div className="h-[18px] hidden lg:block"></div>
            <div className="flex items-center justify-center">
              <NavLink to="/dashboard">
                <img src={imageUrl} alt="Logo" className="h-[7rem] w-[7rem] " />
              </NavLink>
            </div>
          </div>
          {/* <!-- SIDEBAR HEADER --> */}

          <div className="scrollbar-thin flex flex-col overflow-y-auto duration-300 ease-linear">
            {/* <!-- Sidebar Menu --> */}
            <nav className="mt-5 pt-4 pb-8 px-4 lg:mt-0 lg:px-4">
              {/* <!-- Menu Group --> */}
              <div>
                <h1 className="mb-4 ml-4 text-sm text-textPrimary">MENU</h1>

                <ul className="mb-1  flex flex-col gap-1.5">
                  <li>
                    <NavLink
                      to="/dashboard"
                      className={({ isActive }) =>
                        `group relative flex items-center hover:bg-[#445B9E] gap-3 rounded-md py-2 pl-5.5 font-medium text-textPrimary duration-300 ease-in-out dark:hover:bg-meta-4 ${pathname.match("/dashboard") ||
                          pathname.includes("vacant-position") ||
                          pathname.includes("applied-position") ||
                          pathname.includes("archived-position")
                          ? "bg-[#445B9E] dark:bg-meta-4"
                          : ""
                        }` +
                        (pathname.match("/dashboard") ||
                          pathname.includes("vacant-position") ||
                          pathname.includes("applied-position") ||
                          pathname.includes("archived-position")
                          ? "!bg-[#445B9E] !font-semibold"
                          : "")
                      }
                    >
                      <img src={dashboard} alt="" className="w-5 h-5" />
                      <h1 className="text-base md:text-sm  text-textPrimary">
                        Dashboard
                      </h1>
                    </NavLink>
                  </li>
                  {/* <!-- Menu Item Dashboard --> */}
                  {/* <!-- Menu Item Profile --> */}
                  <li>
                    <NavLink
                      to={
                        saveChecker === true
                          ? "/personal-data-sheet"
                          : "/personal-data-sheet-form"
                      }
                      className={({ isActive }) =>
                        `group relative flex items-center hover:bg-[#445B9E] gap-3 rounded-md py-2 pl-5.5 font-medium text-textPrimary duration-300 ease-in-out hover:bg-gray dark:hover:bg-meta-4 ${pathname.includes("personal-data-sheet") ||
                          pathname.includes("personal-data-sheet-form")
                          ? "bg-[#445B9E] dark:bg-meta-4"
                          : ""
                        }` +
                        (pathname.includes("personal-data-sheet") ||
                          pathname.includes("personal-data-sheet-form")
                          ? "!bg-[#445B9E] !font-semibold"
                          : "")
                      }
                    >
                      <img src={pds} alt="" className="w-5 h-5" />

                      <h1 className="text-base md:text-sm  text-textPrimary">
                        Personal Data Sheet (e-PDS)
                      </h1>
                    </NavLink>
                  </li>
                  <li className={(onboardingID == '') ? "hidden" : ""}>
                    <NavLink
                      to="/onboarding"
                      className={({ isActive }) =>
                        "group relative flex items-center hover:bg-[#445B9E] gap-3 rounded-md py-2 pl-5.5 font-medium text-textPrimary duration-300 ease-in-out hover:bg-gray dark:hover:bg-meta-4 " +
                        ((pathname.includes("competency-based-profile") &&
                          !pathname.includes("-for/")) ||
                          (pathname.includes("phase") &&
                            !pathname.includes("-for/") &&
                            !pathname.includes("-coaching/") &&
                            !pathname.includes("-mentoring/")) ||
                          pathname === "/onboarding"
                          ? "bg-[#445B9E] dark:bg-meta-4 font-semibold"
                          : "")
                      }
                    >
                      <img src={pds} alt="" className="w-5 h-5" />
                      <h1 className="text-base md:text-sm  text-textPrimary">
                        My Onboarding
                      </h1>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/my-exams"
                      className={({ isActive }) =>
                        `${"group relative flex items-center gap-3 rounded-md pl-5.5 w-full py-2 font-medium text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] " +
                        ((pathname === "/pen-test" ||
                          pathname === "/my-exams") &&
                          "!bg-[#445B9E] !font-semibold")
                        }`
                      }
                    >
                      <FaPencilAlt className="w-5 h-5" />
                      <h1 className="text-base md:text-sm  text-textPrimary">
                        My Exam
                      </h1>
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      to="/my-schedule"
                      className={({ isActive }) =>
                        `${"group relative flex items-center gap-3 rounded-md pl-5.5 w-full py-2 font-medium text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] " +
                        ((pathname === "/my-schedule" ||
                          pathname === "/my-schedule") &&
                          "!bg-[#445B9E] !font-semibold")
                        }`
                      }
                    >
                      <FaPencilAlt className="w-5 h-5" />
                      <h1 className="text-base md:text-sm  text-textPrimary">
                        My Schedule
                      </h1>
                    </NavLink>
                  </li>
                  {/* <li>
                    <NavLink
                      to={"/messages"}
                      className={({ isActive }) =>
                        `group relative flex items-center hover:bg-[#445B9E] gap-3 rounded-md py-2 pl-5.5 font-medium text-textPrimary duration-300 ease-in-out hover:bg-gray dark:hover:bg-meta-4 ${
                          pathname.includes("messages")
                            ? "bg-[#445B9E] dark:bg-meta-4"
                            : ""
                        }` +
                        (pathname.includes("messages")
                          ? "!bg-[#445B9E] !font-semibold"
                          : "")
                      }
                    >
                      <img src={email} alt="" className="w-5 h-5"/>

                      <h1 className="text-base md:text-sm  text-textPrimary">
                        Messages
                      </h1>
                    </NavLink>
                  </li> */}
                  <SidebarLinkGroup
                    activeCondition={
                      pathname === "/messages" ||
                      (pathname.includes("messages") &&
                        pathname === "/archived-messages") ||
                      pathname.includes("archived-messages")
                    }
                  >
                    {(handleClick, open) => {
                      return (
                        <React.Fragment>
                          <NavLink
                            to="#"
                            className={`${isEmployee
                              ? "group relative flex items-center hover:bg-[#445B9E] gap-3 rounded-md py-2 px-5.5 font-medium text-textPrimary duration-300 ease-in-out hover:bg-gray dark:hover:bg-meta-4"
                              : "hidden"
                              } ${(pathname === "/messages" ||
                                pathname.includes("messages")) &&
                              "bg-[#445B9E] dark:bg-meta-4"
                              } `}
                            onClick={(e) => {
                              e.preventDefault();
                              handleClick();
                            }}
                          >
                            <img src={email} alt="" className="w-5 h-5" />

                            <h1 className="text-base md:text-sm  text-textPrimary">
                              Messages
                            </h1>
                            <svg
                              className={`absolute right-4 top-1/2 -translate-y-1/2 fill-current ${open && "rotate-180"
                                }`}
                              width="18"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M4.41107 6.9107C4.73651 6.58527 5.26414 6.58527 5.58958 6.9107L10.0003 11.3214L14.4111 6.91071C14.7365 6.58527 15.2641 6.58527 15.5896 6.91071C15.915 7.23614 15.915 7.76378 15.5896 8.08922L10.5896 13.0892C10.2641 13.4147 9.73651 13.4147 9.41107 13.0892L4.41107 8.08922C4.08563 7.76378 4.08563 7.23614 4.41107 6.9107Z"
                                fill=""
                              />
                            </svg>
                          </NavLink>

                          <div
                            className={`translate transform overflow-y-hidden ${!open && "hidden"
                              }`}
                          >
                            <ul className="mt-1 mb-0 flex flex-col gap-2.5 pl-8">
                              <li
                                className={`${isEmployee ? "block" : "hidden"}`}
                              >
                                <NavLink
                                  to="/messages"
                                  className={`${isEmployee
                                    ? "group relative flex items-center gap-2.5 rounded-md pl-7 w-full h-[2rem] font-semibold text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] "
                                    : "hidden"
                                    }  ${pathname.match("/messages") &&
                                    "bg-[#445B9E] dark:bg-meta-4 !font-semibold"
                                    }`}
                                >
                                  <h1 className="text-base md:text-[13px]  text-textPrimary">
                                    Inbox/Outbox
                                  </h1>
                                </NavLink>
                              </li>
                            </ul>{" "}
                            <ul className="mt-1 mb-0 flex-col gap-2.5 pl-8">
                              <li
                                className={`${isEmployee ? "block" : "hidden"}`}
                              >
                                <NavLink
                                  to="/archived-messages"
                                  className={`${isEmployee
                                    ? "group relative flex items-center gap-2.5 rounded-md pl-7 w-full h-[2rem] font-semibold text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] "
                                    : "hidden"
                                    }  ${pathname.includes("archived-messages") &&
                                    "bg-[#445B9E] dark:bg-meta-4 !font-semibold"
                                    }`}
                                >
                                  <h1 className="text-base md:text-[13px]  text-textPrimary">
                                    Archived Messages
                                  </h1>
                                </NavLink>
                              </li>
                            </ul>{" "}
                          </div>
                        </React.Fragment>
                      );
                    }}
                  </SidebarLinkGroup>
                  <li className={`${isAdmin ? "hidden" : "hidden"}`}>
                    <NavLink
                      to="/leave-application"
                      className={({ isActive }) =>
                        `group relative flex items-center hover:bg-[#445B9E] gap-4 rounded-md py-2 pl-6 font-medium text-textPrimary duration-300 ease-in-out hover:bg-gray dark:hover:bg-meta-4 ${pathname.includes("leave-application")
                          ? "bg-[#445B9E] dark:bg-meta-4"
                          : ""
                        }` +
                        (pathname.includes("leave-application")
                          ? "!bg-[#445B9E] !font-semibold"
                          : "")
                      }
                    >
                      <img src={dashboard} alt="" className="w-4 h-4" />
                      <h1 className="text-base md:text-sm  text-textPrimary">
                        Leave Application
                      </h1>
                    </NavLink>
                  </li>
                  <li className={`${isAdmin ? "hidden" : "hidden"}`}>
                    <NavLink
                      to="/travel-order"
                      className={({ isActive }) =>
                        `group relative flex items-center hover:bg-[#445B9E] gap-4 rounded-md py-2 pl-6 font-medium text-textPrimary duration-300 ease-in-out hover:bg-gray dark:hover:bg-meta-4 ${pathname.includes("travel-order")
                          ? "bg-[#445B9E] dark:bg-meta-4"
                          : ""
                        }` +
                        (pathname.includes("travel-order")
                          ? "!bg-[#445B9E] !font-semibold"
                          : "")
                      }
                    >
                      <img src={dashboard} alt="" className="w-4 h-4" />
                      <h1 className="text-base md:text-sm  text-textPrimary">
                        Travel Order
                      </h1>
                    </NavLink>
                  </li>
                  <li className={`${isAdmin ? "hidden" : "hidden"}`}>
                    <NavLink
                      to="/pass-slip"
                      className={({ isActive }) =>
                        `group relative flex items-center hover:bg-[#445B9E] gap-4 rounded-md py-2 pl-6 font-medium text-textPrimary duration-300 ease-in-out hover:bg-gray dark:hover:bg-meta-4 ${pathname.includes("pass-slip")
                          ? "bg-[#445B9E] dark:bg-meta-4"
                          : ""
                        }` +
                        (pathname.includes("pass-slip")
                          ? "!bg-[#445B9E] !font-semibold"
                          : "")
                      }
                    >
                      <img src={dashboard} alt="" className="w-4 h-4" />
                      <h1 className="text-base md:text-sm  text-textPrimary">
                        Pass Slip
                      </h1>
                    </NavLink>
                  </li>
                  {/* <!-- Menu Item Profile --> */}
                  {/* <!-- Menu Item Calendar --> */}
                  <li>
                    <NavLink
                      to="/calendar"
                      className={`group relative hidden  items-center hover:bg-[#445B9E] gap-2.5 rounded-md py-2 px-4 font-medium text-textPrimary duration-300 ease-in-out hover:bg-gray dark:hover:bg-meta-4 ${pathname.includes("calendar") &&
                        "bg-[#445B9E] dark:bg-meta-4"
                        }`}
                    >
                      <svg
                        className="fill-current"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.7499 2.9812H14.2874V2.36245C14.2874 2.02495 14.0062 1.71558 13.6405 1.71558C13.2749 1.71558 12.9937 1.99683 12.9937 2.36245V2.9812H4.97803V2.36245C4.97803 2.02495 4.69678 1.71558 4.33115 1.71558C3.96553 1.71558 3.68428 1.99683 3.68428 2.36245V2.9812H2.2499C1.29365 2.9812 0.478027 3.7687 0.478027 4.75308V14.5406C0.478027 15.4968 1.26553 16.3125 2.2499 16.3125H15.7499C16.7062 16.3125 17.5218 15.525 17.5218 14.5406V4.72495C17.5218 3.7687 16.7062 2.9812 15.7499 2.9812ZM1.77178 8.21245H4.1624V10.9968H1.77178V8.21245ZM5.42803 8.21245H8.38115V10.9968H5.42803V8.21245ZM8.38115 12.2625V15.0187H5.42803V12.2625H8.38115ZM9.64678 12.2625H12.5999V15.0187H9.64678V12.2625ZM9.64678 10.9968V8.21245H12.5999V10.9968H9.64678ZM13.8374 8.21245H16.228V10.9968H13.8374V8.21245ZM2.2499 4.24683H3.7124V4.83745C3.7124 5.17495 3.99365 5.48433 4.35928 5.48433C4.7249 5.48433 5.00615 5.20308 5.00615 4.83745V4.24683H13.0499V4.83745C13.0499 5.17495 13.3312 5.48433 13.6968 5.48433C14.0624 5.48433 14.3437 5.20308 14.3437 4.83745V4.24683H15.7499C16.0312 4.24683 16.2562 4.47183 16.2562 4.75308V6.94683H1.77178V4.75308C1.77178 4.47183 1.96865 4.24683 2.2499 4.24683ZM1.77178 14.5125V12.2343H4.1624V14.9906H2.2499C1.96865 15.0187 1.77178 14.7937 1.77178 14.5125ZM15.7499 15.0187H13.8374V12.2625H16.228V14.5406C16.2562 14.7937 16.0312 15.0187 15.7499 15.0187Z"
                          fill=""
                        />
                      </svg>
                      <h1 className="text-sm text-textPrimary">Calendar</h1>
                    </NavLink>
                  </li>
                  {/* <!-- Menu Item Calendar --> */}
                  <div className="block">
                    <h3 className="mt-4 ml-4 text-sm  text-textPrimary">
                      4 CORE
                    </h3>
                  </div>
                  {/* <!-- Menu Item Profile --> */}
                  <li className={`${isAdmin ? "block" : "hidden"}`}>
                    <NavLink
                      to="/admin-dashboard"
                      className={`${isAdmin
                        ? "group relative hidden  items-center hover:bg-[#445B9E] gap-2.5 rounded-md py-2 px-4 font-medium text-textPrimary duration-300 ease-in-out hover:bg-gray dark:hover:bg-meta-4"
                        : "hidden"
                        }  ${pathname.includes("admin-dashboard") &&
                        "bg-[#445B9E] dark:bg-meta-4 !font-semibold"
                        }`}
                    >
                      <TbDashboard className="w-5 h-5" />
                      <h1 className="text-base md:text-sm  text-textPrimary">
                        Admin Dashboard
                      </h1>
                    </NavLink>
                  </li>{" "}
                  {/* 4 Core */}
                  <>
                    <SidebarLinkGroup
                      activeCondition={
                        pathname === "/table" ||
                        pathname.includes("table") ||
                        pathname.includes("job-position") ||
                        pathname.includes("applicant") ||
                        pathname.includes("Prequalification") ||
                        pathname.includes("prequalification") ||
                        pathname.includes("delisting") ||
                        pathname.includes("phase-1-pre-boarding-for") ||
                        pathname.includes("phase-2-orientation-phase-for") ||
                        pathname.includes("phase-3-immersion-phase-for") ||
                        pathname.includes("phase-4-exploration-phase-for") ||
                        pathname.includes("phase-5-discovery-phase-for") ||
                        pathname.includes("phase-6-engagement-phase-for") ||
                        pathname.includes("competency-based-profile-for") ||
                        pathname.includes("Scoring") ||
                        pathname.includes("/employees-for-onboarding") ||
                        pathname.includes("/overall-onboarding-report-for") ||
                        pathname.match("/stage-3:-consolidated-scoring") ||
                        pathname.match("/Qualified-Applicants-Template")
                      }
                    >
                      {(handleClick, open) => {
                        return (
                          <React.Fragment>
                            <NavLink
                              className={`${deletePreQualIsPresent ||
                                editPreQualIsPresent ||
                                addPreQualIsPresent ||
                                isCoachMentor ||
                                onboardingIsPresent ||
                                isDeptHead ||
                                (onboardingID != '') ||
                                userTasks?.some(
                                  (item) =>
                                    item ===
                                    "00000000-0000-AAAA-AAAA-000000000008" ||
                                    item ===
                                    "00000000-0000-AAAA-AAAA-000000000001" ||
                                    item === TaskConsts.ViewOnlyStage1 ||
                                    item === TaskConsts.ViewOnlyStage2 ||
                                    item === TaskConsts.ViewOnlyStage3
                                )
                                || bigContextState?.hrmpsbVisible
                                ? "group relative flex items-center hover:bg-[#445B9E] gap-2.5 rounded-md py-2 px-6 h-[2rem] font-medium text-textPrimary duration-300 ease-in-out hover:bg-gray dark:hover:bg-meta-4"
                                : "hidden"
                                } ${(pathname === "/table" ||
                                  pathname.includes("table") ||
                                  pathname.includes("applicant") ||
                                  pathname.includes("Prequalification") ||
                                  pathname.includes("prequalification") ||
                                  pathname.includes("delisting") ||
                                  pathname.includes("preliminary") ||
                                  pathname.includes(
                                    "phase-1-pre-boarding-for"
                                  ) ||
                                  pathname.includes(
                                    "phase-2-orientation-phase-for"
                                  ) ||
                                  pathname.includes(
                                    "phase-3-immersion-phase-for"
                                  ) ||
                                  pathname.includes(
                                    "phase-4-exploration-phase-for"
                                  ) ||
                                  pathname.includes(
                                    "phase-5-discovery-phase-for"
                                  ) ||
                                  pathname.includes(
                                    "phase-6-engagement-phase-for"
                                  ) ||
                                  pathname.includes(
                                    "competency-based-profile"
                                  ) ||
                                  pathname.includes("Scoring") ||
                                  pathname.includes(
                                    "/employees-for-onboarding"
                                  ) ||
                                  pathname.includes(
                                    "/overall-onboarding-report-for"
                                  ) ||
                                  pathname.includes(
                                    "/coaching-and-mentorship"
                                  ) ||
                                  pathname.includes("/HRMPSB-scoring") ||
                                  pathname.match(
                                    "/stage-3:-consolidated-scoring"
                                  ) ||
                                  pathname.match(
                                    "/Qualified-Applicants-Template"
                                  ) ||
                                  pathname.includes(
                                    "background-investigation"
                                  ) ||
                                  pathname.includes(
                                    "simulations-performance"
                                  ) ||
                                  pathname.includes("/results")) &&
                                "bg-[#445B9E] dark:bg-meta-4"
                                } `}
                              onClick={(e) => {
                                e.preventDefault();
                                handleClick();
                              }}
                            >
                              <img src={RSP} alt="" className="w-6 h-6" />

                              <h1 className="text-base md:text-sm  text-textPrimary">
                                RSP
                              </h1>

                              <svg
                                className={`absolute right-4 top-1/2 -translate-y-1/2 fill-current ${open && "rotate-180"
                                  }`}
                                width="18"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M4.41107 6.9107C4.73651 6.58527 5.26414 6.58527 5.58958 6.9107L10.0003 11.3214L14.4111 6.91071C14.7365 6.58527 15.2641 6.58527 15.5896 6.91071C15.915 7.23614 15.915 7.76378 15.5896 8.08922L10.5896 13.0892C10.2641 13.4147 9.73651 13.4147 9.41107 13.0892L4.41107 8.08922C4.08563 7.76378 4.08563 7.23614 4.41107 6.9107Z"
                                  fill=""
                                />
                              </svg>
                            </NavLink>

                            <div
                              className={`translate transform overflow-y-hidden  ${!open && "hidden"
                                }`}
                            >
                              <ul
                                className={`${deletePreQualIsPresent ||
                                  editPreQualIsPresent ||
                                  addPreQualIsPresent ||
                                  userTasks?.some(
                                    (item) =>
                                      item === TaskConsts.ViewOnlyStage1 ||
                                      item === TaskConsts.ViewOnlyStage2 ||
                                      item === TaskConsts.ViewOnlyStage3 ||
                                      item ===
                                      "00000000-0000-0000-0000-000000000001" ||
                                      item ===
                                      "00000000-0000-0000-0000-000000000005" ||
                                      item ===
                                      "00000000-0000-0000-0000-000000000004"
                                  )
                                  ? "mt-1 mb-1 flex flex-col gap-2.5 pl-6"
                                  : "hidden"
                                  }`}
                              >
                                <li>
                                  <NavLink
                                    to="/prequalification-table"
                                    className={({ isActive }) =>
                                      "group relative flex items-center gap-2.5 rounded-md pl-6 w-full h-[2rem] font-medium text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] " +
                                      ((pathname.includes("applicant") ||
                                        pathname.includes("Prequalification") ||
                                        pathname.includes("prequalification") ||
                                        pathname.includes("delisting") ||
                                        pathname.includes("Scoring") ||
                                        pathname.includes("preliminary") ||
                                        pathname.includes("consolidated") ||
                                        pathname.includes(
                                          "/background-investigation-form"
                                        ) ||
                                        pathname.includes(
                                          "/simulations-performance-sheet"
                                        ) ||
                                        pathname.includes("preliminary") ||
                                        pathname.includes(
                                          "/background-investigation-report"
                                        )) &&
                                        !pathname.includes("HRMPSB-applicants")
                                        ? "!bg-[#445B9E] !font-semibold"
                                        : "")
                                    }
                                  >
                                    <h1 className="text-base md:text-[13px] text-textPrimary">
                                      Screening and Selection
                                    </h1>
                                  </NavLink>
                                </li>
                              </ul>
                              <ul
                                className={`${bigContextState?.hrmpsbVisible
                                  ? "mt-1 mb-1 flex flex-col gap-2.5 pl-6"
                                  : "hidden"
                                  }`}
                              >
                                <li>
                                  <NavLink
                                    to="/HRMPSB-table"
                                    className={({ isActive }) =>
                                      `${"group relative flex items-center gap-2.5 rounded-md pl-6.5 w-full h-[2rem] font-medium text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] " +
                                      (pathname.includes("/HRMPSB") &&
                                        "!bg-[#445B9E] !font-semibold")
                                      }`
                                    }
                                  >
                                    <h1 className="text-base md:text-sm  text-textPrimary">
                                      HRMPSB
                                    </h1>
                                  </NavLink>
                                </li>
                              </ul>
                              <ul
                                className={`${!userTasks?.some(
                                  (item) =>
                                    item ===
                                    "00000000-0000-AAAA-AAAA-000000000008"
                                )
                                  ? "hidden"
                                  : "mt-1 mb-1 flex flex-col gap-2.5 pl-6"
                                  }`}
                              >
                                <li>
                                  <NavLink
                                    to="/results"
                                    className={({ isActive }) =>
                                      `${"group relative flex items-center gap-2.5 rounded-md pl-6.5 w-full h-[2rem] font-medium text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] " +
                                      ((pathname.includes("-results") ||
                                        pathname.includes(
                                          "/edit-simulations-performance-sheet"
                                        ) ||
                                        pathname.includes("/results") ||
                                        pathname.includes(
                                          "/edit-background-investigation-form"
                                        ) ||
                                        pathname.includes(
                                          "/edit-background-investigation-report"
                                        )) &&
                                        "!bg-[#445B9E] !font-semibold")
                                      }`
                                    }
                                  >
                                    <h1 className="text-base md:text-sm  text-textPrimary">
                                      Results
                                    </h1>
                                  </NavLink>
                                </li>
                              </ul>

                              <ul
                                className={`${!onboardingIsPresent && !isDeptHead && (onboardingID == '')
                                  ? "hidden"
                                  : "mt-1 mb-1 flex flex-col gap-2.5 pl-6"
                                  }`}
                              >
                                {(onboardingIsPresent || isDeptHead) &&
                                  <li>
                                    <NavLink
                                      to="/employees-for-onboarding"
                                      className={({ isActive }) =>
                                        `${"group relative flex items-center gap-2.5 rounded-md pl-6.5 w-full h-[2rem] font-medium text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] " +
                                        ((pathname.includes(
                                          "/employees-for-onboarding"
                                        ) ||
                                          pathname.includes(
                                            "/overall-onboarding-report-for"
                                          ) ||
                                          pathname.includes(
                                            "adding-to-onboarding"
                                          ) ||
                                          (pathname.includes(
                                            "competency-based-profile"
                                          ) &&
                                            pathname.includes("-for/")) ||
                                          (pathname.includes("phase") &&
                                            pathname.includes("-for/"))) &&
                                          "!bg-[#445B9E] !font-semibold")
                                        }`
                                      }
                                    >
                                      <h1 className="text-base md:text-sm  text-textPrimary">
                                        Employees for Onboarding
                                      </h1>
                                    </NavLink>
                                  </li>
                                }

                                {(onboardingID != '') &&
                                  <li>
                                    <NavLink
                                      to={"/phase-1-pre-boarding-for/" + onboardingID + '/' + id}
                                      className={({ isActive }) =>
                                        `${"group relative flex items-center gap-2.5 rounded-md pl-6.5 w-full h-[2rem] font-medium text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] " +
                                        ((pathname.includes(
                                          "/employees-for-onboarding"
                                        ) ||
                                          pathname.includes(
                                            "/overall-onboarding-report-for"
                                          ) ||
                                          pathname.includes(
                                            "adding-to-onboarding"
                                          ) ||
                                          (pathname.includes(
                                            "competency-based-profile"
                                          ) &&
                                            pathname.includes("-for/")) ||
                                          (pathname.includes("phase") &&
                                            pathname.includes("-for/"))) &&
                                          "!bg-[#445B9E] !font-semibold")
                                        }`
                                      }
                                    >
                                      <h1 className="text-base md:text-sm  text-textPrimary">
                                        Onboarding
                                      </h1>
                                    </NavLink>
                                  </li>
                                }

                                {/* <li>
                                  <NavLink
                                    to="/employees-for-onboarding2"
                                    className={({ isActive }) =>
                                      `${"group relative flex items-center gap-2.5 rounded-md pl-6.5 w-full h-[2rem] font-medium text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] " +
                                      ((pathname.includes(
                                        "/employees-for-onboarding2"
                                      ) ||
                                        pathname.includes(
                                          "/overall-onboarding-report-for"
                                        ) ||
                                        pathname.includes(
                                          "adding-to-onboarding"
                                        ) ||
                                        (pathname.includes(
                                          "competency-based-profile"
                                        ) &&
                                          pathname.includes("-for/")) ||
                                        (pathname.includes("phase") &&
                                          pathname.includes("-for/"))) &&
                                        "!bg-[#445B9E] !font-semibold")
                                      }`
                                    }
                                  >
                                    <h1 className="text-base md:text-sm  text-textPrimary">
                                      Employees for Onboarding (new)
                                    </h1>
                                  </NavLink>
                                </li> */}

                                <li>
                                  <NavLink
                                    to="/hired-applicants"
                                    className={({ isActive }) =>
                                      `${!isAdmin
                                        ? "hidden"
                                        : "group relative flex items-center gap-2.5 rounded-md pl-6.5 w-full h-[2rem] font-medium text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] " +
                                        (pathname.includes(
                                          "list-of-competencies"
                                        ) &&
                                          "!bg-[#445B9E] !font-semibold")
                                      }`
                                    }
                                  >
                                    <h1 className="text-base md:text-sm  text-textPrimary">
                                      Hired Applicants
                                    </h1>
                                  </NavLink>
                                </li>
                              </ul>
                              <ul
                                className={`${!isCoachMentor
                                  ? "hidden"
                                  : "mt-1 mb-1 flex flex-col gap-2.5 pl-6"
                                  }`}
                              >
                                <li>
                                  <NavLink
                                    to="/coaching-and-mentorship"
                                    className={({ isActive }) =>
                                      `${"group relative flex items-center gap-2.5 rounded-md pl-6.5 w-full h-[2rem] font-medium text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] " +
                                      ((pathname.includes(
                                        "/coaching-and-mentorship"
                                      ) ||
                                        pathname.includes(
                                          "phase-4-exploration-phase:-coaching/"
                                        ) ||
                                        pathname.includes(
                                          "phase-4-exploration-phase:-mentoring/"
                                        )) &&
                                        "!bg-[#445B9E] !font-semibold")
                                      }`
                                    }
                                  >
                                    <h1 className="text-base md:text-sm  text-textPrimary">
                                      Coaching and Mentorship
                                    </h1>
                                  </NavLink>
                                </li>
                              </ul>
                              {/* <ul
                                className={`${
                                  !userTasks?.some(
                                    (item) =>
                                      item ===
                                      "00000000-0000-AAAA-AAAA-000000000008"
                                  )
                                    ? "hidden"
                                    : "mt-1 mb-1 flex flex-col gap-2.5 pl-6"
                                }`}
                              >
                                <li>
                                  <NavLink
                                    to="/simulations-performance-results"
                                    className={({ isActive }) =>
                                      `${
                                        "group relative flex items-center gap-2.5 rounded-md pl-6.5 w-full h-[2rem] font-medium text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] " +
                                        ((pathname.includes(
                                          "/simulations-performance-results"
                                        ) ||
                                          pathname.includes(
                                            "/edit-simulations-performance-sheet"
                                          )) &&
                                          "!bg-[#445B9E] !font-semibold")
                                      }`
                                    }
                                  >
                                    <h1 className="text-base md:text-sm  text-textPrimary">
                                      Simulation Results
                                    </h1>
                                  </NavLink>
                                </li>
                              </ul> */}
                            </div>
                          </React.Fragment>
                        );
                      }}
                    </SidebarLinkGroup>

                    {/* <ul className="mt-0 mb-1 flex flex-col">
                      <li className={`${isAdmin ? "block" : "hidden"}`}>
                        <NavLink
                          to="/Page-Under-Construction"
                          className={`group relative flex items-center hover:bg-[#445B9E] gap-2.5 py-2 rounded-md h-[2rem] px-6 font-medium text-textPrimary duration-300 ease-in-out hover:bg-gray dark:hover:bg-meta-4 ${
                            pathname.includes("Compose-Email") &&
                            "bg-[#445B9E] dark:bg-meta-4 !font-semibold"
                          }`}
                        >
                          <img src={LD} alt="" className="w-6 h-6" />
                          <h1 className="text-base md:text-sm  text-textPrimary">
                            L & D
                          </h1>
                        </NavLink>
                      </li>
                    </ul>

                    <ul className="mt-0 mb-1 flex flex-col">
                      <li className={`${isAdmin ? "block" : "hidden"}`}>
                        <NavLink
                          to="/Page-Under-Construction"
                          className={`group relative flex items-center hover:bg-[#445B9E] gap-2.5 py-2 rounded-md h-[2rem] px-6 font-medium text-textPrimary duration-300 ease-in-out hover:bg-gray dark:hover:bg-meta-4 ${
                            pathname.includes("Compose-Email") &&
                            "bg-[#445B9E] dark:bg-meta-4 !font-semibold"
                          }`}
                        >
                          <img src={PM} alt="" className="w-6 h-6" />
                          <h1 className="text-base md:text-sm  text-textPrimary">
                            PM
                          </h1>
                        </NavLink>
                      </li>
                    </ul> */}

                    <ul className="mt-0 mb-1 flex flex-col">
                      <SidebarLinkGroup
                        activeCondition={
                          pathname === "/list-of-awards" ||
                          pathname.includes("list-of-awards")
                        }
                      >
                        {(handleClick, open) => {
                          return (
                            <React.Fragment>
                              <NavLink
                                to="#"
                                className={`${isAdmin || isJudge
                                  ? "group relative flex items-center hover:bg-[#445B9E] gap-2.5 rounded-md h-[2rem] py-2 px-6 font-medium text-textPrimary duration-300 ease-in-out hover:bg-gray dark:hover:bg-meta-4"
                                  : "hidden"
                                  } ${(pathname.includes("nomination") ||
                                    pathname.includes("nominees") ||
                                    pathname.includes("summary") ||
                                    pathname.includes("scores-per-criteria") ||
                                    pathname.includes("edit-event-award")) &&
                                  "bg-[#445B9E] dark:bg-meta-4"
                                  } `}
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleClick();
                                }}
                              >
                                <img src={RR} alt="" className="w-6 h-6" />

                                <h1 className="text-base md:text-sm  text-textPrimary">
                                  R & R
                                </h1>
                                <svg
                                  className={`absolute right-4 top-1/2 -translate-y-1/2 fill-current ${open && "rotate-180"
                                    }`}
                                  width="18"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M4.41107 6.9107C4.73651 6.58527 5.26414 6.58527 5.58958 6.9107L10.0003 11.3214L14.4111 6.91071C14.7365 6.58527 15.2641 6.58527 15.5896 6.91071C15.915 7.23614 15.915 7.76378 15.5896 8.08922L10.5896 13.0892C10.2641 13.4147 9.73651 13.4147 9.41107 13.0892L4.41107 8.08922C4.08563 7.76378 4.08563 7.23614 4.41107 6.9107Z"
                                    fill=""
                                  />
                                </svg>
                              </NavLink>
                              {/* <!-- Dropdown Menu Start --> */}
                              <div
                                className={`translate transform overflow-y-hidden ${!open && "hidden"
                                  }`}
                              >
                                <ul
                                  className={`${!isAdmin
                                    ? "hidden"
                                    : " mt-1 mb-1 flex flex-col gap-2.5 pl-6"
                                    }`}
                                >
                                  <li>
                                    <NavLink
                                      to="/nomination"
                                      className={({ isActive }) =>
                                        `${!userTasks?.some(
                                          (item) =>
                                            item ===
                                            "00000000-0000-AAAA-BBBB-000000000001"
                                        )
                                          ? "hidden"
                                          : "group relative flex items-center gap-2.5 rounded-md pl-6.5 w-full h-[2rem] font-medium text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] " +
                                          ((pathname.includes(
                                            "nomination"
                                          ) ||
                                            pathname.includes(
                                              "nomination"
                                            ) ||
                                            pathname.includes(
                                              "edit-event-award"
                                            ) ||
                                            pathname.includes(
                                              "list-of-nominees"
                                            ) ||
                                            pathname.includes(
                                              "add-nominees"
                                            ) ||
                                            pathname.includes(
                                              "list-of-judges"
                                            ) ||
                                            pathname.includes(
                                              "add-judges"
                                            ) ||
                                            pathname.includes(
                                              "list-of-office-nominees"
                                            ) ||
                                            pathname.includes(
                                              "add-office-nominees"
                                            )) &&
                                            "!bg-[#445B9E] !font-semibold")
                                        }`
                                      }
                                    >
                                      <h1 className="text-base md:text-sm  text-textPrimary">
                                        Nomination
                                      </h1>
                                    </NavLink>
                                  </li>
                                </ul>
                                <ul
                                  className={`${!isAdmin && !isJudge
                                    ? "hidden"
                                    : "mt-1 mb-1 flex flex-col gap-2.5 pl-6"
                                    }`}
                                >
                                  <li>
                                    <NavLink
                                      to="/summary"
                                      className={`${userTasks?.some(
                                        (item) =>
                                          item === TaskConsts.SummaryOfScores
                                      )
                                        ? "group relative flex items-center gap-2.5 rounded-md pl-6.5 w-full h-[2rem] font-medium text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] " +
                                        ((pathname.includes("summary") ||
                                          pathname.includes(
                                            "scores-per-criteria"
                                          )) &&
                                          "!bg-[#445B9E] !font-semibold")
                                        : "hidden"
                                        }`}
                                    >
                                      <h1 className="text-base md:text-sm  text-textPrimary">
                                        Summary of scores
                                      </h1>
                                    </NavLink>
                                  </li>
                                </ul>
                                <ul
                                  className={`${!isJudge
                                    ? "hidden"
                                    : "mt-1 mb-1 flex flex-col gap-2.5 pl-6"
                                    }`}
                                >
                                  <li>
                                    <NavLink
                                      to="/judges'-ratings"
                                      className={({ isActive }) =>
                                        `${!isJudge
                                          ? "hidden"
                                          : "group relative flex items-center gap-2.5 rounded-md pl-6.5 w-full h-[2rem] font-medium text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] " +
                                          ((pathname.includes(
                                            "judges'-ratings"
                                          ) ||
                                            pathname.includes(
                                              "score-for-nominees"
                                            ) ||
                                            pathname.includes(
                                              "nominee-score"
                                            )) &&
                                            "!bg-[#445B9E] !font-semibold")
                                        }`
                                      }
                                    >
                                      <h1 className="text-base md:text-sm  text-textPrimary">
                                        Give Score
                                      </h1>
                                    </NavLink>
                                  </li>
                                </ul>
                              </div>
                              {/* <!-- Dropdown Menu End --> */}
                            </React.Fragment>
                          );
                        }}
                      </SidebarLinkGroup>
                    </ul>
                  </>
                  {/* ENd of 4 COre */}
                  {/* Data Analysis */}
                  <div className="mt-4"></div>
                  <SidebarLinkGroup
                    activeCondition={pathname.includes("-dashboard")}
                  >
                    {(handleClick, open) => {
                      return (
                        <React.Fragment>
                          <NavLink
                            to="#"
                            className={`${usersisPresent
                              ? "group relative flex items-center hover:bg-[#445B9E] gap-3 rounded-md py-2 px-4.5 font-medium text-textPrimary duration-300 ease-in-out hover:bg-gray dark:hover:bg-meta-4"
                              : "hidden"
                              } ${pathname.includes("-dashboard") &&
                              "bg-[#445B9E] dark:bg-meta-4"
                              } `}
                            onClick={(e) => {
                              e.preventDefault();
                              handleClick();
                            }}
                          >
                            <img src={data} alt="" className="w-5 h-5" />

                            <h1 className="text-base md:text-sm  text-textPrimary">
                              Data Analysis
                            </h1>
                            <svg
                              className={`absolute right-4 top-1/2 -translate-y-1/2 fill-current ${open && "rotate-180"
                                }`}
                              width="18"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M4.41107 6.9107C4.73651 6.58527 5.26414 6.58527 5.58958 6.9107L10.0003 11.3214L14.4111 6.91071C14.7365 6.58527 15.2641 6.58527 15.5896 6.91071C15.915 7.23614 15.915 7.76378 15.5896 8.08922L10.5896 13.0892C10.2641 13.4147 9.73651 13.4147 9.41107 13.0892L4.41107 8.08922C4.08563 7.76378 4.08563 7.23614 4.41107 6.9107Z"
                                fill=""
                              />
                            </svg>
                          </NavLink>

                          {/* Sub Menu for Data Analysis */}
                          <div
                            className={`translate transform overflow-y-hidden ${!open && "hidden"
                              }`}
                          >
                            <ul className="mt-1 mb-0 flex flex-col gap-2.5 pl-8">
                              <li
                                className={`${userTasks?.some(
                                  (item) =>
                                    item ===
                                    "00000000-0000-AAAA-EEEE-000000000001"
                                )
                                  ? "block"
                                  : "hidden"
                                  }`}
                              >
                                <NavLink
                                  to="/hiring-dashboard"
                                  className={`${userTasks?.some(
                                    (item) =>
                                      item ===
                                      "00000000-0000-AAAA-EEEE-000000000001"
                                  )
                                    ? "group relative flex items-center gap-2.5 rounded-md pl-7 w-full h-[2rem] font-semibold text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] "
                                    : "hidden"
                                    }  ${pathname.includes("hiring-dashboard") &&
                                    "bg-[#445B9E] dark:bg-meta-4 !font-semibold"
                                    }`}
                                >
                                  <h1 className="text-base md:text-[13px]  text-textPrimary">
                                    Hiring Dashboard
                                  </h1>
                                </NavLink>
                              </li>
                            </ul>
                            <ul className="mt-1 mb-0 flex flex-col gap-2.5 pl-8">
                              <li
                                className={`${userTasks?.some(
                                  (item) =>
                                    item ===
                                    "00000000-0000-AAAA-EEEE-000000000002" ||
                                    item === TaskConsts.ViewOnlyStage1 ||
                                    item === TaskConsts.ViewOnlyStage2 ||
                                    item === TaskConsts.ViewOnlyStage3
                                )
                                  ? "block"
                                  : "hidden"
                                  }`}
                              >
                                <NavLink
                                  to="/Page-Under-Construction"
                                  className={`${userTasks?.some(
                                    (item) =>
                                      item ===
                                      "00000000-0000-AAAA-EEEE-000000000002"
                                  )
                                    ? "group relative flex items-center gap-2.5 rounded-md pl-7 w-full h-[2rem] font-semibold text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] "
                                    : "hidden"
                                    }  ${pathname.includes("/sad") &&
                                    "bg-[#445B9E] dark:bg-meta-4 !font-semibold"
                                    }`}
                                >
                                  <h1 className="text-base md:text-[13px]  text-textPrimary">
                                    RSP Dashboard
                                  </h1>
                                </NavLink>
                              </li>
                            </ul>
                            {/* <ul className="mt-1 mb-0 flex flex-col gap-2.5 pl-8">
                              <li
                                className={`${
                                  userTasks?.some(
                                    (item) =>
                                      item ===
                                      "00000000-0000-AAAA-EEEE-000000000003"
                                  )
                                    ? "block"
                                    : "hidden"
                                }`}
                              >
                                <NavLink
                                  to="/Page-Under-Construction"
                                  className={`${
                                    userTasks?.some(
                                      (item) =>
                                        item ===
                                        "00000000-0000-AAAA-EEEE-000000000003"
                                    )
                                      ? "group relative flex items-center gap-2.5 rounded-md pl-7 w-full h-[2rem] font-semibold text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] "
                                      : "hidden"
                                  }  ${
                                    pathname.includes("/sadsa") &&
                                    "bg-[#445B9E] dark:bg-meta-4 !font-semibold"
                                  }`}
                                >
                                  <h1 className="text-base md:text-[13px]  text-textPrimary">
                                    L&D Dashboard
                                  </h1>
                                </NavLink>
                              </li>
                            </ul> */}
                            <ul className="mt-1 mb-0 flex flex-col gap-2.5 pl-8">
                              <li
                                className={`${userTasks?.some(
                                  (item) =>
                                    item ===
                                    "00000000-0000-AAAA-EEEE-000000000004"
                                )
                                  ? "block"
                                  : "hidden"
                                  }`}
                              >
                                <NavLink
                                  to="/Page-Under-Construction"
                                  className={`${userTasks?.some(
                                    (item) =>
                                      item ===
                                      "00000000-0000-AAAA-EEEE-000000000004"
                                  )
                                    ? "group relative flex items-center gap-2.5 rounded-md pl-7 w-full h-[2rem] font-semibold text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] "
                                    : "hidden"
                                    }  ${pathname.includes("/sd") &&
                                    "bg-[#445B9E] dark:bg-meta-4 !font-semibold"
                                    }`}
                                >
                                  <h1 className="text-base md:text-[13px]  text-textPrimary">
                                    R&R Dashboard
                                  </h1>
                                </NavLink>
                              </li>
                            </ul>
                          </div>
                          {/* <!-- Dropdown Menu End --> */}
                        </React.Fragment>
                      );
                    }}
                  </SidebarLinkGroup>
                  {/* Utilities*/}
                  <SidebarLinkGroup
                    activeCondition={
                      pathname === "/user" ||
                      pathname.includes("user") ||
                      pathname.includes("list-of-roles") ||
                      pathname.includes("job-positions") ||
                      pathname.includes("onboarding-setup") ||
                      pathname.includes("-template") ||
                      pathname.includes("PRAISE-committee") ||
                      pathname.includes("add-new-judge") ||
                      pathname.includes("add-new-award") ||
                      pathname.includes("edit-award") ||
                      pathname.includes("job-position-form") ||
                      pathname.includes("edit-job-position") ||
                      pathname.includes("adding-to-onboarding") ||
                      pathname.includes("add-roles") ||
                      pathname.includes("edit-roles")
                    }
                  >
                    {(handleClick, open) => {
                      return (
                        <React.Fragment>
                          <NavLink
                            to="#"
                            className={`${usersisPresent
                              ? "group relative flex items-center hover:bg-[#445B9E] gap-3 rounded-md py-2 px-4.5 font-medium text-textPrimary duration-300 ease-in-out hover:bg-gray dark:hover:bg-meta-4"
                              : "hidden"
                              } ${(pathname === "/user" ||
                                pathname.includes("user") ||
                                pathname.includes("list-of-awards") ||
                                pathname.includes("list-of-roles") ||
                                pathname.includes("awarding-schedule") ||
                                pathname.includes("job-positions") ||
                                pathname.includes("onboarding-setup") ||
                                pathname.includes("-template") ||
                                pathname.includes("PRAISE-committee") ||
                                pathname.includes("add-new-judge") ||
                                pathname.includes("add-new-award") ||
                                pathname.includes("edit-award") ||
                                pathname.includes("job-position-form") ||
                                pathname.includes("edit-job-position") ||
                                pathname.includes("adding-to-onboarding") ||
                                pathname.includes("add-roles") ||
                                pathname.includes("edit-roles") ||
                                pathname.includes("list-of-departments") ||
                                pathname.includes("list-of-interviewers") ||
                                pathname.includes("add-new-interviewer") ||
                                pathname.includes("raters-for-positions") ||
                                pathname.includes("psychosocial-criteria")) &&
                              "bg-[#445B9E] dark:bg-meta-4"
                              } `}
                            onClick={(e) => {
                              e.preventDefault();
                              handleClick();
                            }}
                          >
                            <img src={set1} alt="" className="w-5 h-5" />

                            <h1 className="text-base md:text-sm  text-textPrimary">
                              Utilities
                            </h1>
                            <svg
                              className={`absolute right-4 top-1/2 -translate-y-1/2 fill-current ${open && "rotate-180"
                                }`}
                              width="18"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M4.41107 6.9107C4.73651 6.58527 5.26414 6.58527 5.58958 6.9107L10.0003 11.3214L14.4111 6.91071C14.7365 6.58527 15.2641 6.58527 15.5896 6.91071C15.915 7.23614 15.915 7.76378 15.5896 8.08922L10.5896 13.0892C10.2641 13.4147 9.73651 13.4147 9.41107 13.0892L4.41107 8.08922C4.08563 7.76378 4.08563 7.23614 4.41107 6.9107Z"
                                fill=""
                              />
                            </svg>
                          </NavLink>

                          {/* Sub Menu for Utilities */}
                          <div
                            className={`translate transform overflow-y-hidden ${!open && "hidden"
                              }`}
                          >
                            {/* RSP */}
                            <ul className="mt-1 mb-1 flex flex-col pl-6">
                              <SidebarLinkGroup
                                activeCondition={
                                  pathname.includes("job-positions") ||
                                  pathname.includes("score-templates") ||
                                  pathname.includes("job-position-form") ||
                                  pathname.includes("edit-job-position") ||
                                  pathname.includes("adding-to-onboarding")
                                }
                              >
                                {(handleClick, open) => {
                                  return (
                                    <React.Fragment>
                                      <NavLink
                                        to="#"
                                        className={`${isAdmin || isJudge
                                          ? "group relative flex items-center hover:bg-[#445B9E] gap-2.5 rounded-md h-[2rem] py-2 px-6 font-medium text-textPrimary duration-300 ease-in-out hover:bg-gray dark:hover:bg-meta-4"
                                          : "hidden"
                                          } ${(pathname.includes("job-positions") ||
                                            pathname.includes(
                                              "score-templates"
                                            ) ||
                                            pathname.includes(
                                              "job-position-form"
                                            ) ||
                                            pathname.includes(
                                              "edit-job-position"
                                            ) ||
                                            pathname.includes(
                                              "adding-to-onboarding"
                                            ) ||
                                            pathname.includes(
                                              "psychosocial-criteria"
                                            ) ||
                                            pathname.includes(
                                              "raters-for-positions"
                                            ) ||
                                            pathname.includes(
                                              "list-of-interviewers"
                                            ) ||
                                            pathname.includes(
                                              "add-new-interviewer"
                                            )) &&
                                          "bg-[#445B9E] dark:bg-meta-4"
                                          } `}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleClick();
                                        }}
                                      >
                                        <img
                                          src={RSP}
                                          alt=""
                                          className="w-6 h-6"
                                        />

                                        <h1 className="text-base md:text-sm  text-textPrimary">
                                          RSP
                                        </h1>
                                        <svg
                                          className={`absolute right-4 top-1/2 -translate-y-1/2 fill-current ${open && "rotate-180"
                                            }`}
                                          width="18"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M4.41107 6.9107C4.73651 6.58527 5.26414 6.58527 5.58958 6.9107L10.0003 11.3214L14.4111 6.91071C14.7365 6.58527 15.2641 6.58527 15.5896 6.91071C15.915 7.23614 15.915 7.76378 15.5896 8.08922L10.5896 13.0892C10.2641 13.4147 9.73651 13.4147 9.41107 13.0892L4.41107 8.08922C4.08563 7.76378 4.08563 7.23614 4.41107 6.9107Z"
                                            fill=""
                                          />
                                        </svg>
                                      </NavLink>
                                      {/* <!-- Dropdown Menu Start --> */}
                                      <div
                                        className={`translate transform overflow-y-hidden ${!open && "hidden"
                                          }`}
                                      >
                                        <ul
                                          className={`${!userTasks?.some(
                                            (item) =>
                                              item ===
                                              "00000000-0000-AAAA-CCCC-000000000001"
                                          )
                                            ? "hidden"
                                            : "mt-1 mb-1 flex flex-col gap-2.5 pl-6"
                                            }`}
                                        >
                                          <li>
                                            <NavLink
                                              to="/job-positions"
                                              className={({ isActive }) =>
                                                `${!isAdmin
                                                  ? "hidden"
                                                  : "group relative flex items-center gap-2.5 rounded-md pl-6.5 w-full h-[2rem] font-medium text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] " +
                                                  ((pathname ===
                                                    "/job-positions" ||
                                                    pathname ===
                                                    "/job-position-form" ||
                                                    pathname ===
                                                    "/edit-job-position") &&
                                                    "!bg-[#445B9E] !font-semibold")
                                                }`
                                              }
                                            >
                                              <h1 className="text-base md:text-sm  text-textPrimary">
                                                Job Postings
                                              </h1>
                                            </NavLink>
                                          </li>

                                          <li>
                                            <NavLink
                                              to="/job-position-batches"
                                              className={({ isActive }) =>
                                                `${!isAdmin
                                                  ? "hidden"
                                                  : "group relative flex items-center gap-2.5 rounded-md pl-6.5 w-full h-[2rem] font-medium text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] " +
                                                  ((pathname ===
                                                    "/job-position-batches") &&
                                                    "!bg-[#445B9E] !font-semibold")
                                                }`
                                              }
                                            >
                                              <h1 className="text-base md:text-sm  text-textPrimary">
                                                Job Posting Batches
                                              </h1>
                                            </NavLink>
                                          </li>

                                        </ul>
                                        <ul
                                          className={`${!userTasks?.some(
                                            (item) =>
                                              item ===
                                              "00000000-0000-AAAA-CCCC-000000000001"
                                          )
                                            ? "hidden"
                                            : "mt-1 mb-1 flex flex-col gap-2.5 pl-6"
                                            }`}
                                        >
                                          <li>
                                            <NavLink
                                              to="/job-positions-master-list"
                                              className={({ isActive }) =>
                                                `${!isAdmin
                                                  ? "hidden"
                                                  : "group relative flex items-center gap-2.5 rounded-md pl-6.5 w-full h-[2rem] font-medium text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] " +
                                                  ((pathname.includes(
                                                    "job-positions-master-list"
                                                  ) ||
                                                    pathname.includes(
                                                      "job-position-form-master-list"
                                                    ) ||
                                                    pathname.includes(
                                                      "edit-job-position-master-list"
                                                    )) &&
                                                    "!bg-[#445B9E] !font-semibold")
                                                }`
                                              }
                                            >
                                              <h1 className="text-base md:text-sm  text-textPrimary">
                                                Positions Master List
                                              </h1>
                                            </NavLink>
                                          </li>
                                        </ul>
                                        <ul
                                          className={`${!userTasks?.some(
                                            (item) =>
                                              item ===
                                              "00000000-0000-AAAA-CCCC-000000000002"
                                          )
                                            ? "hidden"
                                            : "mt-1 mb-1 flex flex-col gap-2.5 pl-6"
                                            }`}
                                        >
                                          <li>
                                            <NavLink
                                              to="/score-templates"
                                              className={({ isActive }) =>
                                                `${!isAdmin
                                                  ? "hidden"
                                                  : "group relative flex items-center gap-2.5 rounded-md pl-6.5 w-full h-[2rem] font-medium text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] " +
                                                  ((pathname.includes(
                                                    "score-templates"
                                                  ) ||
                                                    pathname.includes(
                                                      "-template"
                                                    )) &&
                                                    "!bg-[#445B9E] !font-semibold")
                                                }`
                                              }
                                            >
                                              <h1 className="text-base md:text-sm  text-textPrimary">
                                                Score Templates
                                              </h1>
                                            </NavLink>
                                          </li>
                                        </ul>
                                        <ul
                                          className={`${!userTasks?.some(
                                            (item) =>
                                              item ===
                                              "00000000-0000-AAAA-CCCC-000000000012"
                                          )
                                            ? "hidden"
                                            : "mt-1 mb-1 flex flex-col gap-2.5 pl-6"
                                            }`}
                                        >
                                          <li>
                                            <NavLink
                                              to="/list-of-interviewers"
                                              className={`${isAdmin
                                                ? "group relative flex items-center gap-2.5 rounded-md pl-6 w-full h-[2rem] font-semibold text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] "
                                                : "hidden"
                                                }  ${(pathname.includes(
                                                  "list-of-interviewers"
                                                ) ||
                                                  pathname.includes(
                                                    "add-new-interviewer"
                                                  )) &&
                                                "bg-[#445B9E] dark:bg-meta-4 !font-semibold"
                                                }`}
                                            >
                                              <h1 className="text-base md:text-sm  text-textPrimary">
                                                List Of Interviewers
                                              </h1>
                                            </NavLink>
                                          </li>
                                        </ul>
                                        <ul
                                          className={`${!userTasks?.some(
                                            (item) =>
                                              item ===
                                              "00000000-0000-AAAA-CCCC-000000000004"
                                          )
                                            ? "hidden"
                                            : "mt-1 mb-1 flex flex-col gap-2.5 pl-6"
                                            }`}
                                        >
                                          <li>
                                            <NavLink
                                              to="/raters-for-positions"
                                              className={`${isAdmin
                                                ? "group relative flex items-center gap-2.5 rounded-md pl-6 w-full h-[2rem] font-semibold text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] "
                                                : "hidden"
                                                }  ${pathname.includes(
                                                  "raters-for-positions"
                                                ) &&
                                                "bg-[#445B9E] dark:bg-meta-4 !font-semibold"
                                                }`}
                                            >
                                              <h1 className="text-base md:text-sm  text-textPrimary">
                                                Raters For Positions
                                              </h1>
                                            </NavLink>
                                          </li>
                                        </ul>{" "}
                                        <ul
                                          className={`${!userTasks?.some(
                                            (item) =>
                                              item ===
                                              "00000000-0000-AAAA-CCCC-000000000005"
                                          )
                                            ? "hidden"
                                            : "mt-1 mb-1 flex flex-col gap-2.5 pl-6"
                                            }`}
                                        >
                                          <li>
                                            <NavLink
                                              to="/psychosocial-criteria"
                                              className={`${userTasks?.some(
                                                (item) =>
                                                  item ===
                                                  "00000000-0000-AAAA-CCCC-000000000005"
                                              )
                                                ? "group relative flex items-center gap-2.5 rounded-md pl-6 w-full h-[2rem] font-semibold text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] "
                                                : "hidden"
                                                }  ${pathname.includes(
                                                  "psychosocial-criteria"
                                                ) &&
                                                "bg-[#445B9E] dark:bg-meta-4 !font-semibold"
                                                }`}
                                            >
                                              <h1 className="text-base md:text-sm  text-textPrimary">
                                                Psychosocial Criteria
                                              </h1>
                                            </NavLink>
                                          </li>
                                        </ul>
                                        <ul
                                          className={`${!userTasks?.some(
                                            (item) =>
                                              item ===
                                              "00000000-0000-AAAA-CCCC-000000000003"
                                          )
                                            ? "hidden"
                                            : "mt-1 mb-1 flex flex-col gap-2.5 pl-6"
                                            }`}
                                        >
                                          <li>
                                            <NavLink
                                              to="/onboarding-setup"
                                              className={`${isAdmin
                                                ? "group relative flex items-center gap-2.5 rounded-md pl-6 w-full h-[2rem] font-semibold text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] "
                                                : "hidden"
                                                }  ${pathname.includes(
                                                  "onboarding-setup"
                                                ) &&
                                                "bg-[#445B9E] dark:bg-meta-4 !font-semibold"
                                                }`}
                                            >
                                              <h1 className="text-base md:text-sm  text-textPrimary">
                                                Onboarding Setup
                                              </h1>
                                            </NavLink>
                                          </li>
                                        </ul>
                                        <ul
                                          className={`${!userTasks?.some(
                                            (item) =>
                                              item ===
                                              "00000000-0000-AAAA-CCCC-000000000001"
                                          )
                                            ? "hidden"
                                            : "mt-1 mb-1 flex flex-col gap-2.5 pl-6"
                                            }`}
                                        >
                                          <li>
                                            <NavLink
                                              to="/list-of-competencies"
                                              className={({ isActive }) =>
                                                `${!isAdmin
                                                  ? "hidden"
                                                  : "group relative flex items-center gap-2.5 rounded-md pl-6.5 w-full h-[2rem] font-medium text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] " +
                                                  (pathname.includes(
                                                    "list-of-competencies"
                                                  ) &&
                                                    "!bg-[#445B9E] !font-semibold")
                                                }`
                                              }
                                            >
                                              <h1 className="text-base md:text-sm  text-textPrimary">
                                                List of Competencies
                                              </h1>
                                            </NavLink>
                                          </li>
                                        </ul>

                                        <ul
                                          className={`${!userTasks?.some(
                                            (item) =>
                                              item ===
                                              "00000000-0000-AAAA-CCCC-000000000001"
                                          )
                                            ? "hidden"
                                            : "mt-1 mb-1 flex flex-col gap-2.5 pl-6"
                                            }`}
                                        >
                                          <li>
                                            <NavLink
                                              to="/monitoring-of-submitted-scores"
                                              className={({ isActive }) =>
                                                `${!isAdmin
                                                  ? "hidden"
                                                  : "group relative flex items-center gap-2.5 rounded-md pl-6.5 w-full h-[2rem] font-medium text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] " +
                                                  (pathname.includes(
                                                    "list-of-competencies"
                                                  ) &&
                                                    "!bg-[#445B9E] !font-semibold")
                                                }`
                                              }
                                            >
                                              <h1 className="text-base md:text-sm  text-textPrimary">
                                                Monitoring of Submitted Scores
                                              </h1>
                                            </NavLink>
                                          </li>
                                        </ul>
                                      </div>
                                      {/* <!-- Dropdown Menu End --> */}
                                    </React.Fragment>
                                  );
                                }}
                              </SidebarLinkGroup>
                            </ul>
                            {/* End of RSP */}

                            {/* R & R */}
                            <ul className="mt-1 mb-1 flex flex-col pl-6">
                              <SidebarLinkGroup
                                activeCondition={
                                  pathname === "/list-of-awards" ||
                                  pathname.includes("list-of-awards")
                                }
                              >
                                {(handleClick, open) => {
                                  return (
                                    <React.Fragment>
                                      <NavLink
                                        to="#"
                                        className={`${isAdmin || isJudge
                                          ? "group relative flex items-center hover:bg-[#445B9E] gap-2.5 rounded-md h-[2rem] py-2 px-6 font-medium text-textPrimary duration-300 ease-in-out hover:bg-gray dark:hover:bg-meta-4"
                                          : "hidden"
                                          } ${(pathname === "/list-of-awards" ||
                                            pathname.includes("award") ||
                                            pathname.includes(
                                              "awarding-schedule"
                                            ) ||
                                            pathname.includes(
                                              "PRAISE-committee"
                                            ) ||
                                            pathname.includes(
                                              "add-new-judge"
                                            )) &&
                                          !pathname.includes(
                                            "edit-event-award"
                                          ) &&
                                          "bg-[#445B9E] dark:bg-meta-4"
                                          } `}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleClick();
                                        }}
                                      >
                                        <img
                                          src={RR}
                                          alt=""
                                          className="w-6 h-6"
                                        />

                                        <h1 className="text-base md:text-sm  text-textPrimary">
                                          R & R
                                        </h1>
                                        <svg
                                          className={`absolute right-4 top-1/2 -translate-y-1/2 fill-current ${open && "rotate-180"
                                            }`}
                                          width="18"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M4.41107 6.9107C4.73651 6.58527 5.26414 6.58527 5.58958 6.9107L10.0003 11.3214L14.4111 6.91071C14.7365 6.58527 15.2641 6.58527 15.5896 6.91071C15.915 7.23614 15.915 7.76378 15.5896 8.08922L10.5896 13.0892C10.2641 13.4147 9.73651 13.4147 9.41107 13.0892L4.41107 8.08922C4.08563 7.76378 4.08563 7.23614 4.41107 6.9107Z"
                                            fill=""
                                          />
                                        </svg>
                                      </NavLink>
                                      {/* <!-- Dropdown Menu Start --> */}
                                      <div
                                        className={`translate transform overflow-y-hidden ${!open && "hidden"
                                          }`}
                                      >
                                        <ul
                                          className={`${!userTasks?.some(
                                            (item) =>
                                              item ===
                                              "00000000-0000-AAAA-CCCC-000000000006"
                                          )
                                            ? "hidden"
                                            : "mt-1 mb-0 flex flex-col gap-2.5 pl-6"
                                            }`}
                                        >
                                          <li>
                                            <NavLink
                                              to="/list-of-awards"
                                              className={({ isActive }) =>
                                                `${!isAdmin
                                                  ? "hidden"
                                                  : "group relative flex items-center gap-2.5 rounded-md pl-6.5 w-full h-[2rem] font-semibold text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] " +
                                                  (pathname.includes(
                                                    "list-of-awards"
                                                  ) ||
                                                    pathname.includes(
                                                      "add-new-award"
                                                    ) ||
                                                    pathname.includes(
                                                      "edit-award"
                                                    )
                                                    ? "!bg-[#445B9E] !font-semibold"
                                                    : "")
                                                }`
                                              }
                                            >
                                              <h1 className="text-base md:text-sm  text-textPrimary">
                                                List of awards
                                              </h1>
                                            </NavLink>
                                          </li>
                                        </ul>

                                        <ul
                                          className={`${!userTasks?.some(
                                            (item) =>
                                              item ===
                                              "00000000-0000-AAAA-CCCC-000000000007"
                                          )
                                            ? "hidden"
                                            : "mt-1 mb-1 flex flex-col pl-6"
                                            }`}
                                        >
                                          <li>
                                            <NavLink
                                              to="/awarding-schedule"
                                              className={({ isActive }) =>
                                                `${!isAdmin
                                                  ? "hidden"
                                                  : "group relative flex items-center gap-2.5 rounded-md pl-6.5 w-full h-[2rem] font-medium text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] " +
                                                  (pathname.includes(
                                                    "awarding-schedule"
                                                  ) &&
                                                    "!bg-[#445B9E] !font-semibold")
                                                }`
                                              }
                                            >
                                              <h1 className="text-base md:text-sm  text-textPrimary">
                                                Awarding schedule
                                              </h1>
                                            </NavLink>
                                          </li>
                                        </ul>
                                        <ul
                                          className={`${!userTasks?.some(
                                            (item) =>
                                              item ===
                                              "00000000-0000-AAAA-CCCC-000000000008"
                                          )
                                            ? "hidden"
                                            : "mt-1 mb-1 flex flex-col pl-6"
                                            }`}
                                        >
                                          <li>
                                            <NavLink
                                              to="/PRAISE-committee"
                                              className={({ isActive }) =>
                                                `${!isAdmin
                                                  ? "hidden"
                                                  : "group relative flex items-center gap-2.5 rounded-md pl-6.5 w-full h-[2rem] font-medium text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] " +
                                                  ((pathname.includes(
                                                    "PRAISE-committee"
                                                  ) ||
                                                    pathname.includes(
                                                      "add-new-judge"
                                                    )) &&
                                                    "!bg-[#445B9E] !font-semibold")
                                                }`
                                              }
                                            >
                                              <h1 className="text-base md:text-sm  text-textPrimary">
                                                PRAISE Committee
                                              </h1>
                                            </NavLink>
                                          </li>
                                        </ul>
                                      </div>
                                      {/* <!-- Dropdown Menu End --> */}
                                    </React.Fragment>
                                  );
                                }}
                              </SidebarLinkGroup>
                            </ul>
                            {/* End of  R & R */}

                            {/* User's Information */}
                            <ul className="mt-1 mb-1 flex flex-col pl-6">
                              <SidebarLinkGroup
                                activeCondition={
                                  pathname.includes("list-of-roles") ||
                                  pathname.includes("list-of-roles") ||
                                  pathname.includes(
                                    "user-level-restrictions"
                                  ) ||
                                  pathname.includes("add-roles") ||
                                  pathname.includes("edit-roles") ||
                                  pathname.includes("user")
                                }
                              >
                                {(handleClick, open) => {
                                  return (
                                    <React.Fragment>
                                      <NavLink
                                        to="#"
                                        className={`${isAdmin ||
                                          isJudge ||
                                          departmentIsPresent
                                          ? "group relative flex items-center hover:bg-[#445B9E] gap-2.5 rounded-md h-[2rem] py-2 px-6 font-medium text-textPrimary duration-300 ease-in-out hover:bg-gray dark:hover:bg-meta-4"
                                          : "hidden"
                                          } ${(pathname.includes("list-of-roles") ||
                                            pathname.includes("list-of-user") ||
                                            pathname.includes(
                                              "user-level-restrictions"
                                            ) ||
                                            pathname.includes("add-roles") ||
                                            pathname.includes("edit-roles") ||
                                            pathname.includes("user") ||
                                            pathname.includes(
                                              "list-of-departments"
                                            )) &&
                                          "bg-[#445B9E] dark:bg-meta-4"
                                          } `}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleClick();
                                        }}
                                      >
                                        <img
                                          src={role}
                                          alt=""
                                          className="w-5 h-5"
                                        />

                                        <h1 className="text-base md:text-sm  text-textPrimary">
                                          User's Information
                                        </h1>
                                        <svg
                                          className={`absolute right-4 top-1/2 -translate-y-1/2 fill-current ${open && "rotate-180"
                                            }`}
                                          width="18"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M4.41107 6.9107C4.73651 6.58527 5.26414 6.58527 5.58958 6.9107L10.0003 11.3214L14.4111 6.91071C14.7365 6.58527 15.2641 6.58527 15.5896 6.91071C15.915 7.23614 15.915 7.76378 15.5896 8.08922L10.5896 13.0892C10.2641 13.4147 9.73651 13.4147 9.41107 13.0892L4.41107 8.08922C4.08563 7.76378 4.08563 7.23614 4.41107 6.9107Z"
                                            fill=""
                                          />
                                        </svg>
                                      </NavLink>
                                      {/* <!-- Dropdown Menu Start --> */}
                                      <div
                                        className={`translate transform overflow-y-hidden ${!open && "hidden"
                                          }`}
                                      >
                                        <ul className="mt-1 mb-0 flex flex-col pl-8">
                                          <li
                                            className={`${departmentIsPresent
                                              ? "block"
                                              : "hidden"
                                              }`}
                                          >
                                            <NavLink
                                              to="/list-of-departments"
                                              className={`${departmentIsPresent
                                                ? "group relative flex items-center gap-2.5 rounded-md pl-7 w-full h-[2rem] font-semibold text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E]"
                                                : "hidden"
                                                }  ${pathname.includes(
                                                  "list-of-departments"
                                                ) &&
                                                "bg-[#445B9E] dark:bg-meta-4 !font-semibold"
                                                }`}
                                            >
                                              {/* <img src={role} alt="" className="w-5 h-5"/> */}

                                              <h1 className="text-sm md:text-sm  text-textPrimary">
                                                List of Departments
                                              </h1>
                                            </NavLink>
                                          </li>
                                        </ul>

                                        <ul className="mt-1 mb-0 flex flex-col pl-8">
                                          <li
                                            className={`${isAdmin ? "block" : "hidden"
                                              }`}
                                          >
                                            <NavLink
                                              to="/list-of-roles"
                                              className={`${rolesisPresent
                                                ? "group relative flex items-center gap-2.5 rounded-md pl-7 w-full h-[2rem] font-semibold text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E]"
                                                : "hidden"
                                                }  ${(pathname.includes(
                                                  "list-of-roles"
                                                ) ||
                                                  pathname.includes(
                                                    "add-roles"
                                                  ) ||
                                                  pathname.includes(
                                                    "edit-roles"
                                                  )) &&
                                                "bg-[#445B9E] dark:bg-meta-4 !font-semibold"
                                                }`}
                                            >
                                              {/* <img src={role} alt="" className="w-5 h-5"/> */}

                                              <h1 className="text-sm md:text-sm  text-textPrimary">
                                                List of Roles
                                              </h1>
                                            </NavLink>
                                          </li>
                                        </ul>

                                        <ul
                                          className={`${!usersisPresent
                                            ? "hidden"
                                            : "mt-1 mb-1 flex flex-col gap-2.5 pl-8"
                                            }`}
                                        >
                                          <li>
                                            <NavLink
                                              to="/list-of-user"
                                              className={({ isActive }) =>
                                                "group relative flex items-center gap-2.5 rounded-md pl-7 w-full h-[2rem] font-medium text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] " +
                                                (pathname.includes("-user") &&
                                                  "!bg-[#445B9E] !font-semibold")
                                              }
                                            >
                                              <h1 className="text-base md:text-sm  text-textPrimary">
                                                List of Users
                                              </h1>
                                            </NavLink>
                                          </li>
                                        </ul>

                                        <ul
                                          className={`${!userTasks?.some(
                                            (item) =>
                                              item ===
                                              "00000000-0000-AAAA-CCCC-000000000011"
                                          )
                                            ? "hidden"
                                            : "mt-1 mb-1 flex flex-col gap-2.5 pl-8"
                                            }`}
                                        >
                                          <li>
                                            <NavLink
                                              to="/user-level-restrictions"
                                              className={({ isActive }) =>
                                                "group relative flex items-center gap-2.5 rounded-md pl-7 w-full h-[2rem] font-medium text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] " +
                                                (isActive &&
                                                  "!bg-[#445B9E] !font-semibold")
                                              }
                                            >
                                              <h1 className="text-base md:text-sm  text-textPrimary">
                                                User Level Restrictions
                                              </h1>
                                            </NavLink>
                                          </li>
                                        </ul>
                                      </div>
                                      {/* <!-- Dropdown Menu End --> */}
                                    </React.Fragment>
                                  );
                                }}
                              </SidebarLinkGroup>
                            </ul>
                            {/* <ul
                              className={`${
                                departmentIsPresent
                                  ? "mt-1 mb-0 flex flex-col gap-2.5 pl-8"
                                  : "hidden"
                              }`}
                            >
                              <li>
                                <NavLink
                                  to="/list-of-departments"
                                  className={({ isActive }) =>
                                    "group relative flex items-center gap-2.5 rounded-md pl-7 w-full h-[2rem] font-medium text-textPrimary duration-300 ease-in-out hover:bg-[#445B9E] " +
                                    (isActive && "!bg-[#445B9E] !font-semibold")
                                  }
                                >
                                  <h1 className="text-base md:text-sm  text-textPrimary">
                                    List of Departments
                                  </h1>
                                </NavLink>
                              </li>
                            </ul> */}
                          </div>
                          {/* <!-- Dropdown Menu End --> */}
                        </React.Fragment>
                      );
                    }}
                  </SidebarLinkGroup>
                  {/* End of Utilities */}
                  {/* <!-- Menu Item Trash --> */}
                  <li
                    className={`${userTasks?.some(
                      (item) =>
                        item === "00000000-0000-AAAA-DDDD-000000000001"
                    )
                      ? "block"
                      : "hidden"
                      }`}
                  >
                    <NavLink
                      to="/recycle-bin"
                      className={`group relative flex items-center hover:bg-[#445B9E] gap-3 py-2 rounded-md pl-4.5 font-medium text-textPrimary duration-300 ease-in-out hover:bg-gray dark:hover:bg-meta-4 ${pathname.includes("recycle-bin") &&
                        "bg-[#445B9E] dark:bg-meta-4 !font-semibold"
                        }`}
                    >
                      <img src={recyclebin} alt="" className="w-5 h-5" />

                      <h1 className="text-base md:text-sm  text-textPrimary">
                        Recycle Bin
                      </h1>
                    </NavLink>
                  </li>
                  {/* <!-- Menu Item Trash --> */}
                </ul>
              </div>
            </nav>

            {/* <!-- Sidebar Menu --> */}
          </div>
        </aside>
      </div>
    </>
  );
};

export default Sidebar;
